import { EmptyState } from "@/components/EmptyState/EmptyState"
import { IconButton, Text } from "@/elements"
import { getFragmentData } from "@/gql-clients/experimental/getFragmentData"
import { DraftJobPostingFragmentDoc, MyJobsDraftJobPostsQueryQuery } from "@/gql/graphql"
import { TrashIcon } from "@heroicons/react/24/outline"
import { formatDate } from "date-fns"
import { useState } from "react"
import { JobTitleColorised } from "@/components/JobTitleColorised"
import { DeleteDraftJobPostingModal } from "./DeleteDraftJobPostingModal"

interface Props {
  data: MyJobsDraftJobPostsQueryQuery | undefined
  loading?: boolean
  onClickRow: (id: string) => void
}

export const DraftJobsMobile: React.FC<Props> = ({ data, loading, onClickRow }) => {
  const node =
    data?.node?.__typename === "IndividualClient" || data?.node?.__typename === "IndividualCreative" ? data.node : null
  const edges = node?.jobPostings?.edges || []
  const [deleteJobPostingModalOpen, setDeleteJobPostingModalOpen] = useState(false)

  return (
    <div className="bg-white flex w-full flex-col sm:hidden">
      {edges.map((edge, index) => {
        const jobNode = getFragmentData(DraftJobPostingFragmentDoc, edge?.node)

        return (
          <div className="flex w-full flex-col" key={jobNode?.id}>
            <div className="flex flex-row gap-x-2 py-6" onClick={() => onClickRow(jobNode?.id!)}>
              <div className="flex flex-col gap-y-2">
                <Text variant="label" className="text-fg-2">
                  {formatDate(jobNode?.createdAt, "MMM d, yyyy")}
                </Text>
                <JobTitleColorised
                  jobPost={jobNode}
                  commonWordColor="text-fg-1"
                  focusWordColor="text-fg-1"
                  textVariant="h6"
                />
              </div>
              <div className="ml-auto shrink-0">
                <div className="flex items-center justify-center">
                  <IconButton
                    variant="white"
                    Icon={TrashIcon}
                    size="small"
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      setDeleteJobPostingModalOpen(true)
                    }}
                  />
                </div>
              </div>
            </div>
            <DeleteDraftJobPostingModal
              jobId={jobNode?.id || ""}
              open={deleteJobPostingModalOpen}
              onClose={() => setDeleteJobPostingModalOpen(false)}
              typename={jobNode?.__typename!}
            />
            {index !== edges.length - 1 && <div className="h-[1px] w-full bg-bg-3" />}
          </div>
        )
      })}

      {!loading && edges.length === 0 ? (
        <div className="mt-[54px] flex w-full justify-center">
          <EmptyState title="No closed jobs" description="You don't have any closed jobs." />
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}
